type Props = { children: React.ReactNode; tone?: "ink" | "bone" };
export function SectionLabel({ children, tone = "bone" }: Props) {
  const color = tone === "ink" ? "text-ink/70" : "text-bone/60";
  return (
    <span
      className={`inline-flex items-center gap-3 font-display text-[11px] uppercase tracking-[0.4em] ${color}`}
    >
      <span className="h-px w-8 bg-current opacity-50" />
      {children}
    </span>
  );
}
